import {Select} from "antd";
import {useState, useEffect, useMemo} from "react";
import i18n from "i18next";
import {
    detectedInitialLang,
    normalizeLang,
    setAppLanguage,
    onLanguageChange,
} from "../../utils/LangUtils/langStorage";

const ALLOWED = ["kk", "ru", "en"];

export const LanguageHeader = () => {
    const [language, setLanguage] = useState(() =>
        normalizeLang(detectedInitialLang())
    );

    useEffect(() => {
        const off = onLanguageChange((ln) => setLanguage(normalizeLang(ln)));
        return off;
    }, []);

    const onChangeLanguage = (ln) => {
        const val = normalizeLang(ln);
        if (!ALLOWED.includes(val)) return;
        setAppLanguage(val);
        setLanguage(val);
    };

    const options = useMemo(
        () => [
            {value: "kk", label: "Қазақша"},
            {value: "ru", label: "Русский"},
            {value: "en", label: "English"},
        ],
        []
    );

    return (
        <div className="App">
            <div className="fixed top-3 right-3 z-50 bg-bgPage px-4 py-2 rounded-md shadow">
                <div className="flex justify-center items-center rounded-b-lg w-full max-w-96 h-12  m-auto">
                    <div>
                        <Select
                            onChange={onChangeLanguage}
                            value={language}
                            className="w-26 mx-auto"
                            options={options}
                        >
                        </Select>
                    </div>
                </div>
            </div>
        </div>
    )
}